import { render, staticRenderFns } from "./BuildingUsers.vue?vue&type=template&id=22adb931&scoped=true"
import script from "./BuildingUsers.vue?vue&type=script&lang=js"
export * from "./BuildingUsers.vue?vue&type=script&lang=js"
import style0 from "./BuildingUsers.vue?vue&type=style&index=0&id=22adb931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22adb931",
  null
  
)

export default component.exports